import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";

export default function FaqPage() {
  useSeo({
    title: "常见问题 | 匿名投稿与隐私保护答疑 - 爆料51",
    description:
      "关于爆料51的常见问题解答：投稿是否会被追溯到身份、需要提供多少证据、如何收到匿名回执、哪些内容不在受理范围，以及投稿内容的留存与清理规则。",
    keywords: "爆料51常见问题,匿名投稿答疑,隐私保护,保密机制,安全爆料",
    path: "/faq",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://skycv.cn/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: "https://skycv.cn/faq" },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.answer },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <PageHero
        eyebrow="Questions & Answers"
        title="常见问题：先把顾虑说清楚"
        subtitle="投稿前最常被问到的问题都在这里。如果看完还有疑问，可以直接通过匿名通道把问题提交给我们，不需要留下联系方式。"
        crumbs={[{ label: "首页", to: "/" }, { label: "常见问题" }]}
      />

      <section className="bg-background-50 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            <aside className="lg:col-span-4">
              <div className="lg:sticky lg:top-28">
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-4">
                  共 {faqs.length} 个常见问题
                </h2>
                <p className="text-sm leading-relaxed text-foreground-600">
                  这些问题覆盖了身份安全、证据要求、处理反馈与内容留存四个方面，基本可以解答投稿前的主要顾虑。
                </p>

                <div className="mt-8 bg-primary-950 rounded-lg p-6">
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950 mb-4">
                    <i className="ri-question-answer-line text-xl" aria-hidden="true"></i>
                  </span>
                  <h3 className="font-heading font-semibold text-base text-background-50 mb-2">没有找到答案？</h3>
                  <p className="text-sm leading-relaxed text-background-200 mb-5">
                    你可以把疑问当作一次投稿提交，我们会以同样的保密机制处理。
                  </p>
                  <Link
                    to="/submit"
                    className="inline-flex items-center gap-2 text-sm font-medium text-accent-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    匿名提问
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </Link>
                </div>

                <p className="mt-6 text-xs text-foreground-500 leading-relaxed">
                  如需邮件联系，可发送至 {siteInfo.email}，回复周期约 {siteInfo.replyWindow}。
                </p>
              </div>
            </aside>

            <div className="lg:col-span-8">
              <FaqAccordion items={faqs} defaultOpen={0} />
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}